import { Box, Container, Grid, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { t } from "i18next";
import ArrowPicture from "../../assets/arrow_header_userlevel.svg";
import TabsUserLevel from "../../components/atomic/tabs-user-level";
import { useEffect } from "react";

const UserLevel = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "  سطوح کاربری";
  }, []);
  return (
    <Box sx={{ bgcolor: "background.default", py: 4 }}>
      <Container maxWidth="xl" sx={{ mr: 0, pr: { xs: 0 } }}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Typography
              variant="h4"
              component="h1"
              sx={{ color: "text.primary" }}
            >
              {t("rabsana_user_levels")}
            </Typography>
            <Typography
              variant="subtitle1"
              component="p"
              sx={{ color: "text.secondary", mt: 2.5 }}
            >
              ما در پارسیان بیت چهار سطح کاربری داریم که شما با کامل کردن احراز
              هویت خود میتوانید از تمامی خدمات ما استفاده کنید{" "}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box>
              <img src={ArrowPicture} alt="header picture" width="100%" />
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Container sx={{ my: 5 }}>
        <Box
          sx={{
            bgcolor: "background.darkBlack",
            px: { xs: 1, md: 3 },
            py: 3,
            borderRadius: "10px",
          }}
        >
          <Stack>
            <Typography
              variant="subtitle1"
              component="p"
              sx={{ color: "text.secondary", mt: 2.5 }}
            >
              سطوح حساب کاربری در پارسیان بیت ۴ سطح میباشد
            </Typography>
          </Stack>
          <TabsUserLevel />
        </Box>
      </Container>
    </Box>
  );
};

export default UserLevel;
